import { setYear } from './set-year';
/**
 * @hidden
 */
export var normalizeYear = function (value, year) { return (setYear(value, year(value.getFullYear()))); };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-date-math/dist/es/normalize-year.js
// module id = 211
// module chunks = 0